var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"providers"},_vm._l((_vm.serviceproviderList),function(serviceprovider){return _c('SingleProvider',{key:serviceprovider.id,class:{ButtonAction: _vm.ClassDis === true && _vm.PassId !== serviceprovider.id },attrs:{"serviceprovider":serviceprovider},on:{"passDisable":_vm.disableButon}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }